import * as types from "./actionTypes";
import axios from "axios";

export const getCategories =()=>(dispatch)=>{
        dispatch({type:types.GET_CATEGORY_REQUEST});
        return axios.get("http://54.206.125.24:8888/api/categories/")
        .then((response)=>{
      
            dispatch({type:types.GET_CATEGORY_SUCCESS,payload:response.data})
        })
        .catch((err)=>{
            console.log("category err",err)
            dispatch({type:types.GET_CATEGORY_FAILURE,payload:err})
        })
}

export const getTypes =()=>(dispatch)=>{
    dispatch({type:types.GET_TYPES_REQUEST});
    return axios.get("http://54.206.125.24:8888/api/types/")
    .then((response)=>{
    
        dispatch({type:types.GET_TYPES_SUCCESS,payload:response.data});
    })
    .catch((err)=>{
        console.log("types err",err)
        dispatch({type:types.GET_TYPES_FAILURE,payload:err})
    })
}

export const getInstructors =()=>(dispatch)=>{
    console.log("hi ins")
    dispatch({type:types.GET_INSTRUCTORS_REQUEST});
    return axios.get("http://54.206.125.24:8888/api/users/adminusers")
    .then((response)=>{
        
        dispatch({type:types.GET_INSTRUCTORS_SUCCESS,payload:response.data})
    })
    .catch((err)=>{
        console.log("instructor err",err)
        dispatch({type:types.GET_INSTRUCTORS_FAILURE,payload:err})
    })
}
